import { useSelector } from 'react-redux';
import SkeletonNewsBlock from '../../../universal_components/Skeletots/SkeletonNewsBlock';
import styles from './WebinarsList.module.scss';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarsList = () => {
  const webinarsList = useSelector((state) => state.webinars.webinars);
  const filterYear = useSelector((state) => state.webinars.filterYearWebinars);

  const filteredWebinars = filterYear
    ? webinarsList.filter((webin) => new Date(webin.date).getFullYear() === filterYear)
    : webinarsList;

  if (webinarsList.length === 0) {
    return (
      <ul className={styles.list}>
        {Array.from({ length: 6 }).map((_, index) => (
          <SkeletonNewsBlock key={index} width={240} height={243} />
        ))}
      </ul>
    );
  }

  return (
    <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
      {filteredWebinars.map((item) => {
        return (
          <li className={styles.item} key={item.id}>
            <Link to={`/webinars/${item.id}`}>
              <div className={styles.image}>
                <img src={item.cover} alt={item.title} />
              </div>

              <h3 className={styles.title}>{item.title}</h3>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default WebinarsList;
